import React from "react";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface SidebarButtonProps {
  icon: LucideIcon | React.ComponentType<{ className?: string }>;
  isActive: boolean;
  onClick: () => void;
  className?: string;
  testId?: string;
}

export const SidebarButton: React.FC<SidebarButtonProps> = React.memo(
  ({ icon: Icon, isActive, onClick, className, testId }) => {
    return (
      <button
        data-testid={testId}
        onClick={onClick}
        className={cn(
          "flex justify-center items-center rounded-md size-8 hover:bg-secondary-n-900 transition-colors",
          isActive ? "bg-secondary-n-800!" : "text-secondary-n-400",
          className,
        )}
      >
        <Icon className="size-5" />
      </button>
    );
  },
);

SidebarButton.displayName = "SidebarButton";
